export function isTestUserEmail(email: string) {
	return email.startsWith('atolive');
}
